import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommandProgressStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { TimelineComponent } from './timeline.item/timeline.item.container';

@Component({
  selector: 'ml-timeline',
  templateUrl: './timeline.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TimelineComponent],
})
export class TimelineContainerComponent {
  private readonly store = inject(Store);

  public readonly commands = this.store.selectSignal(
    CommandProgressStoreSelectors.selectCommandProgressesForCurrentUdid
  );
}
